var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextArea',{attrs:{"placeholder":"Label"},model:{value:(_vm.localValue.label),callback:function ($$v) {_vm.$set(_vm.localValue, "label", $$v)},expression:"localValue.label"}})}
var staticRenderFns = []

export { render, staticRenderFns }